export default __webpack_public_path__ + "static/media/ru.e5bf6355.png";